import axios from 'axios';
import {
  PERFORMING_LOGIN,
  LOGIN_FAILURE,
  PERFORMING_LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  LOGIN_SUCCESS
} from './AuthConstants';
import { resetInvoiceFilters } from "../invoiceFilters/InvoiceFiltersActions";

const genericErrorMessage = 'Some error occurred...';

const iamUrl = 'v1/iam';

const logingOut = () => ({ type: PERFORMING_LOGOUT });
const logoutSuccess = () => ({ type: LOGOUT_SUCCESS });

const logoutFailure = message => ({ type: LOGOUT_FAILURE, message });

const reportLogoutSuccess = () => dispatch => dispatch(logoutSuccess());

const logout = () => async dispatch => {
  dispatch(logingOut());
  try {
    await axios.post(`${iamUrl}/logout`, {});
    dispatch(reportLogoutSuccess());
  } catch (error) {
    dispatch(logoutFailure(error.data.error || genericErrorMessage));
    throw error;
  }
};

const otpLogin = () => async dispatch => {
  dispatch({ type: PERFORMING_LOGIN });
  try {
    await axios.post(`${iamUrl}/otp-login`, {});
    dispatch(resetInvoiceFilters());
    dispatch({ type: LOGIN_SUCCESS });
  } catch (e) {
    dispatch({ type: LOGIN_FAILURE });
  }
};

export { reportLogoutSuccess, logout, otpLogin };



// WEBPACK FOOTER //
// ./src/redux/auth/AuthActions.js